export const IMAGE_DIMENSIONS = {
  width: 1080, // If you change these, update placeholder in image (https://via.placeholder.com/1080)
  height: 1080
}

export const IMAGE_STORAGE_ROOT_LOCATION = 'callImages'
